import Inicial from "../../Components/Inicial/Rondomica";


function Home() {
    return ( 
        <>
        <section>
           
            <div>
                <Inicial />
            </div>
        </section>
        
        </>
     );
}

export default Home;

